import { CircularProgress, Typography } from "@mui/material";
import { getUserInfo } from "appredux/actions/showActions";
import endpointMaker from "appredux/endpoints";
import { selectUserInfo, selectUserInfoLoading } from "appredux/user/userSlice";
import MDAlert from "components/MDAlert";
import MDButton from "components/MDButton";
import request from "http/request";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "notistack";

export const useVerifyEmail = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleSendVerificationEmail = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setLoading(true);

    try {
      await request.postJson(
        `${endpointMaker.api.baseUrl}/farm.php?task=resendVerifyEmail`,
        JSON.stringify({
          task: "resendVerifyEmail",
          host: window.location.host,
        }),
        null
      );

      // @ts-ignore
      await dispatch(getUserInfo(localStorage.getItem("farm")));

      await new Promise((resolve) => setTimeout(resolve, 1000));

      enqueueSnackbar("Verification email sent. Please check your inbox.", {
        variant: "success",
        anchorOrigin: {
          vertical: "top",
          horizontal: "center",
        },
      });
    } catch (error) {
      console.error(error);

      enqueueSnackbar("We couldn’t send the email. Please try again.", {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "center",
        },
      });
    } finally {
      setLoading(false);
    }
  };

  return {
    sendVerificationEmail: handleSendVerificationEmail,
    loading,
  };
};

export default function VerifyBanner() {
  const userInfo = useSelector(selectUserInfo);
  const userInfoLoading = useSelector(selectUserInfoLoading);
  const { sendVerificationEmail, loading } = useVerifyEmail();

  if (userInfo?.verified) {
    return null;
  }

  if (userInfoLoading === "succeeded" && userInfo?.verified === false) {
    return (
      <MDAlert color="info" dismissible={false} sx={{ display: "flex", justifyContent: "center" }}>
        <Typography variant="body2" margin={"0 auto"}>
          Please verify your email. You can find the verification email in your inbox.
          {userInfo?.isVerificationLinkExpired && (
            <MDButton
              variant="outlined"
              onClick={sendVerificationEmail}
              size="small"
              sx={{ marginLeft: 1 }}
              disabled={loading}
            >
              Re-send verification email{" "}
              {loading ? <CircularProgress size={12} color="inherit" sx={{ marginLeft: 1 }} /> : ""}
            </MDButton>
          )}
        </Typography>
      </MDAlert>
    );
  }

  return null;
}
